/**
 * Template variables that can be used in the Customer Messages Templates
 */
export const templateVarsObj = {
  applicantFullName: '{applicantFullName}',
  coApplicantFullName: '{coApplicantFullName}',
  coOwnerFullName: '{coOwnerFullName}',
  nooFullName: '{nooFullName}',
  tsFullName: '{tsFullName}',
  tsPhone: '{tsPhone}',
  tsEmail: '{tsEmail}',
  hecFullName: '{hecFullName}',
  hecPhone: '{hecPhone}',
  hecEmail: '{hecEmail}',
}

type interpolateVarsProps = {
  template: string
  values: Record<string, string>
}

/**
 * Replaces template variables with their corresponding values.
 * @param template The template string
 * @param values The object containing the values to replace the variables with
 * @returns The template string with the variables replaced.
 */
export function interpolateVarsInTemplate({ template, values }: interpolateVarsProps) {
  if (!template) return ''
  return template.replace(/{(.*?)}/g, (_, key) => {
    return values[key] || `{${key}}`
  })
}
